import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/ar/chart-object-vessel-button/chart-object-vessel-button.js';
      import {SpeedIndicator, State, Type} from '@oicl/openbridge-webcomponents/dist/ar/chart-object-vessel-button/chart-object-vessel-button.js';
import {VesselImage} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/vessel.js';

      export interface Props {
     heading?: number;
     course?: number;
     speedIndicator?: SpeedIndicator;
     turnRate?: number;
     number?: number | undefined;
     name?: string | undefined;
     state?: State;
     type?: Type;
     selected?: boolean;
     courseArrowPx?: number | undefined;
     ownShipIndicator?: boolean;
     vesselImage?: VesselImage | null;
     vesselImageSize?: number
   }

      
  
      export type {SpeedIndicator, State, Type} from '@oicl/openbridge-webcomponents/dist/ar/chart-object-vessel-button/chart-object-vessel-button.js';
export type {VesselImage} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/vessel.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcChartObjectVesselButton',
  props: {
    heading: {},
    course: {},
    speedIndicator: {},
    turnRate: {},
    number: {},
    name: {},
    state: {},
    type: {},
    selected: { type: Boolean },
    courseArrowPx: {},
    ownShipIndicator: { type: Boolean },
    vesselImage: {},
    vesselImageSize: {}
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-chart-object-vessel-button',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})